export default function Footer() {
  return (
    <>
      <div className="footer_spacing"></div>
      <footer className="border-t border-border bg-card py-8">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-text-tertiary text-sm font-mono">
              © {new Date()?.getFullYear()} VOID LEGIONS HUB. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href="https://discord.gg/DnYc97phK7" 
                target="_blank"
                className="text-text-secondary hover:text-accent transition-colors duration-300"
              >
                Discord
              </a>
              <a 
                href="https://www.tiktok.com/@voidlegionsoficial" 
                target="_blank"
                className="text-text-secondary hover:text-accent transition-colors duration-300"
              >
                TikTok
              </a>
              <a 
                href="https://www.youtube.com/@voidlegionsoficial" 
                target="_blank"
                className="text-text-secondary hover:text-accent transition-colors duration-300"
              >
                YouTube
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
